import dayJs, { ConfigType } from 'dayjs'
import isToday from 'dayjs/plugin/isToday'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import isYesterday from 'dayjs/plugin/isYesterday'
import updateLocale from 'dayjs/plugin/updateLocale'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParser from 'dayjs/plugin/customParseFormat'
import { useTranslation } from 'react-i18next'
import { useMe } from '../me'
import 'dayjs/locale/en'
import 'dayjs/locale/da'
import 'dayjs/locale/de'
import 'dayjs/locale/en'
import 'dayjs/locale/en-au'
import 'dayjs/locale/en-gb'
import 'dayjs/locale/es'
import 'dayjs/locale/fi'
import 'dayjs/locale/fr'
import 'dayjs/locale/is'
import 'dayjs/locale/it'
import 'dayjs/locale/nl'
import 'dayjs/locale/nb'
import 'dayjs/locale/pt'
import 'dayjs/locale/sv'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/zh-tw'
import 'dayjs/locale/ja'
import { useCallback } from 'react'

dayJs.extend(utc)
dayJs.extend(timezone)
dayJs.extend(isToday)
dayJs.extend(isYesterday)
dayJs.extend(updateLocale)
dayJs.extend(relativeTime)
dayJs.extend(customParser)

export const useDayJs = () => {
  const { i18n } = useTranslation()
  const { timeZone } = useMe()

  dayJs.locale(i18n.language)

  const getDayJs = useCallback(
    (date?: ConfigType) => dayJs.tz(dayJs(date), timeZone),
    [timeZone],
  )

  return getDayJs
}
